/** @prettier */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import ExternalLink from '@xanadu/ui-shared/components/widgets/ExternalLink';
import { FIC_URL, NGB_URL, NWGB_URL, PLUS18_URL, SARGF_URL } from '@xanadu/ui-shared/constants';

import LOGO_PLUS18 from '../../../../../images/footer/Logo_18Plus_Light.svg';
import LOGO_FIC from '../../../../../images/footer/Logo_FIC_Light.png';
import LOGO_NGB from '../../../../../images/footer/Logo_NGB_Light.png';
import LOGO_NWGB from '../../../../../images/footer/Logo_NWGB_Light.png';
import LOGO_SARGF from '../../../../../images/footer/Logo_SARGF_Light.png';
import LOGO_PLUS18_COLORED from '../../../../../images/various/plus18_dark.svg';

// add colored versions
import LicenseContainer from '../LicenseContainer/LicenseContainer';

import styles from './BMRegulators.module.scss';

const regulatorLogos = {
  FIC: LOGO_FIC,
  NGB: LOGO_NGB,
  NWGB: LOGO_NWGB,
  SARGF: LOGO_SARGF,
  PLUS18: LOGO_PLUS18,
  PLUS18_COLORED: LOGO_PLUS18_COLORED,
  FIC_COLORED: LOGO_FIC,
  NGB_COLORED: LOGO_NGB,
  NWGB_COLORED: LOGO_NWGB,
  SARGF_COLORED: LOGO_SARGF,
};

const regulatorURLs = {
  FIC: FIC_URL,
  NGB: NGB_URL,
  NWGB: NWGB_URL,
  SARGF: SARGF_URL,
  PLUS18: PLUS18_URL,
};

const BMRegulators = ({
  title,
  logosPosition = 'top',
  shrunk = false,
  centered = false,
  noText = false,
  displayedRegulators = [],
  colored = false,
}) => {
  const logosClass = classNames({
    [styles.regulationsLogos]: true,
    [styles['regulationsLogos--centered']]: centered,
  });

  const regulatorsClass = classNames({
    [styles.regulations]: true,
    [styles['regulations--shrunk']]: shrunk,
    [styles['regulations--centered']]: centered,
  });

  const logos = (
    <div className={logosClass}>
      {displayedRegulators.map((regulator) => {
        const externalRegExp = /:\/\//;
        const RegulatorLogo = colored
          ? regulatorLogos[`${regulator}_COLORED`]
          : regulatorLogos[regulator];
        const regulatorUrl = regulatorURLs[regulator];
        if (!externalRegExp.test(regulatorUrl)) {
          return (
            <Link to={regulatorUrl} key={regulatorUrl}>
              {regulator !== 'PLUS18' ? (
                <img src={RegulatorLogo} alt={`${regulator}_logo_img`} />
              ) : (
                <RegulatorLogo />
              )}
            </Link>
          );
        }
        return (
          <ExternalLink href={regulatorUrl} key={regulatorUrl}>
            {regulator !== 'PLUS18' ? (
              <img src={RegulatorLogo} alt={`${regulator}_logo_img`} />
            ) : (
              <RegulatorLogo />
            )}
          </ExternalLink>
        );
      })}
    </div>
  );

  return (
    <div className={regulatorsClass}>
      {title ? <div className={styles.title}>{title}</div> : null}
      {logosPosition === 'top' ? logos : null}
      {noText ? null : <LicenseContainer />}
      {logosPosition === 'bottom' ? logos : null}
    </div>
  );
};

BMRegulators.propTypes = {
  title: PropTypes.string,
  logosPosition: PropTypes.oneOf(['top', 'bottom']),
  shrunk: PropTypes.bool,
  centered: PropTypes.bool,
  noText: PropTypes.bool,
  displayedRegulators: PropTypes.array,
  colored: PropTypes.bool,
};

export default BMRegulators;
